module.exports = __webpack_public_path__ + "img/huixianAppImage.28e03a08.png";